import type { FaireProductEntity } from "../../entity_types/product";

export const p_kgqruedjag: FaireProductEntity = {
  token: "p_kgqruedjag",
  type: "product",
  name: 'Crystal Confetti - "Love"',
  brandToken: "b_2qbyxhh869",
  brandName: "Prettygoods",
  imageUrl:
    "https://cdn.faire.com/fastly/b7fa5dbc41e24dddc6fe998d02bd63195299cf37aef6aed734a1fdf2cd265449.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.54,
  description:
    'Tiny, tumbled pieces of crystals.\n\nPerfect for meditation, crystal grids, crafting, or simply adding a touch of sparkle to your space. Scatter them around your home, use them in spell jars, or give them as thoughtful gifts.\n\nThe "LOVE" confetti packet contains rose quartz, rhodochrosite, clear quartz, moonstone, and more. \n\nYou will receive the item pictured.\n\nAll of our crystals, minerals, and specimens are 100% authentic and mined from the earth. ',
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:49.868Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
